import React, { useEffect, useState } from 'react'
import { Button, Spin, Modal, Form, Input, message } from 'antd'
import { updateWithFile } from '../../../services/estimate-field'

const UpdateEstimateModal = ({ showModal, estimateId, onCancel }) => {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  const onChancelClick = () => {
    form.resetFields()
    onCancel()
  }
  const onFinishCallback = (formFields) => {
    setIsLoading(true)
    const data = {
      reason: formFields.reason,
      estimate: estimateId,
    }
    const file = form.getFieldInstance('file').input.files[0]
    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    formData.append('files.file', file, file.name)

    updateWithFile(formData)
      .then(() => {
        message.success('Смета успешно обновлена')
        form.resetFields()
        onCancel()
      })
      .catch(() => {
        message.error('Ошибка обновления сметы')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Modal
      title="Загрузить обновление сметы"
      visible={showModal}
      onCancel={onChancelClick}
      footer={[
        <Button key="back" onClick={onChancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Добавить
        </Button>,
      ]}
    >
      <Spin spinning={isLoading}>
        <Form autoComplete="off" layout="vertical" form={form} size="large" onFinish={onFinishCallback}>
          <Form.Item label="Причина обновления" name="reason" rules={[{ required: true, message: 'Поле обязательно' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Файл сметы с изменениями"
            name="file"
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <Input type="file" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default UpdateEstimateModal
